import React from 'react';
import { Row, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';

import { USERS, USERS_STEPS } from './ConstPaths';
import Body from '../Components/layout/Body';
import LoginNotice from './LoginNotice';

const UPDATE_CLIENT_HELP = `
<div>
  <p>Here is where you can change the info for the current client.</p>
  <p>The Preferred Name is just a short name for the client - it gets displayed in the upper right corner when this client is selected. Many people use a first name for this, but you can enter anything you'd like.
   If you leave the Preferred Name blank, Access Nav will just show 'the client' in the upper right.</p>
  <p>Pronouns are adjustable in an attempt to make little phrases like 'her goals and needs' seem friendlier. (We realize that we are only providing some of all possible choices for pronouns, but we hope that this partial list is at least somewhat helpful.)</p>
  <p>Hit Continue to save the changes.</p>
  <p><strong>Note: </strong> currently you cannot change the client's username.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersUpdateClientContent(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    onChangeAlias,
    onChangePronoun,
  } = props;
  
  const pronounsLegend = `Pronouns`;
  const pronounsId = "pronouns";
  const pronounsBtns = [
    {
      value: 'they',
      label: `They / Them`,
      moreInfo: ''
    },
    {
      value: 'he',
      label: `He / Him`,
      moreInfo: ''
    },
    {
      value: 'she',
      label: `She / Her`,
      moreInfo: ''
    }

  ];

  //this page is active only if you are logged in as practitioner and have a client username already
  const canUpdate = loggedIn && username;
  const practitioner_path = USERS + "/" + USERS_STEPS.PRACTITIONER_VIEW;
  return(
    <>
    {!loggedIn ?
      <LoginNotice message="To update a client, you first need to " />
      :
      (!username) && <p><strong>Note: </strong>You first need to <Link to={practitioner_path}>select a client</Link>.</p> 
    }
    <Row>
      <Col><strong>Client Username:</strong> {username || '<none>'}</Col>
    </Row>

    <Row className="aa-review-row">
      <Col>
        <Form>
          <FormGroup>
            <Label for="alias" className='aa-bold-text'>
              Preferred Name <span className="aa-more-info">(what the client prefers to be called, like 'Emily')</span>
            </Label>
            <Input
              id="alias"
              value={alias || ''}
              onChange={onChangeAlias}
              name="alias"
              type="textfield"
              disabled={!canUpdate}
            />
          </FormGroup>
          <FormGroup tag="fieldset" key={pronounsId}>
            <legend>{pronounsLegend}</legend>
            {pronounsBtns.map((btn, index) =>
              <FormGroup check key={index}>
                <Input
                  id={pronounsId+btn.value}
                  value={btn.value}
                  checked={pronoun===btn.value}
                  onChange={onChangePronoun}
                  name={pronounsId}
                  type="radio"
                  disabled={!canUpdate}
                />
                {' '}
                <Label for={pronounsId+btn.value} check>
                  {btn.label}
                  {' '}
                </Label>
              </FormGroup>
            )}
          </FormGroup>
        </Form>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersUpdateClient(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    onChangeAlias,
    onChangePronoun,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Change Client Info",
    subTitle: "",
    learnMore: {linkText: "Learn More about changing client info",
                title: "Changing client info",
                content: UPDATE_CLIENT_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("***rendering UsersUpdateClient, props: " + JSON.stringify(props));

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersUpdateClientContent 
          loggedIn={loggedIn}
          username={username}
          alias={alias}
          onChangeAlias={onChangeAlias}
          pronoun={pronoun}
          onChangePronoun={onChangePronoun}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersUpdateClient;